// Initialize gtag if it exists
export const gtag = (...args) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
};

// Track page views
export const pageview = (url) => {
  gtag("config", process.env.REACT_APP_GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

// Track custom events
export const event = ({ action, category, label, value }) => {
  gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
